<template>
<section class="login_section">
    <div class="div-block-1040"><img sizes="64.421875px" srcset="images/Logo-p-500.png 500w, images/Logo-p-800.png 800w, images/Main_Logo.png 1000w" alt="" src="images/Main_Logo.png" loading="lazy" class="image-167"></div>
    <div class="w-layout-blockcontainer container-12 w-container ">
        <h1 class="heading-45">Welcome Back!</h1>
        <div class="text-block-201">Let&#x27;s get you logged in</div>
        <div class="text-block-203">New user? <router-link :to="{  name: 'OnboardingQuestions'}" class="link-12">take the quiz <span class="text-span-182">-&gt;</span></router-link>
        </div>
        <div class="div-block-1041 logContain">
            <div class="w-form">
                <form @submit.prevent="onSubmit">
                    <input class="text-field-35 w-input" maxlength="256" name="email-or-phone" v-model="email" data-name="Email Or Phone" placeholder="Enter your email or phone" type="text" id="email-or-phone">
                    <input class="text-field-35 w-input" maxlength="256" name="password" v-model="password" data-name="Password" placeholder="Password" type="password" id="password" required="">
                    <button class="submit-button-6 w-button" :disabled="submitted" style="padding-top:12px; color:#fff">
                        <div v-if="submitted">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                </circle>
                            </svg>
                        </div>
                        <div v-else>
                            <div class="">Log In</div>
                        </div>
                    </button>

                    <div class="text-block-203">Forgot Password? <a href="/forgot-password" class="link-12">click here to reset <span class="text-span-163">-&gt;</span></a></div>
                </form>
                <div class="w-form-done">
                    <div>Thank you! Your submission has been received!</div>
                </div>
                <div class="w-form-fail" style="display:block;" v-if="err">
                    <div v-html="errmsg">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
export default {
    name: 'LoginPage',
    props: ['baseUrl'],
    data() {
        return {
            email: null,
            password: null,
            submitted: false,
            err: false,
            errmsg: "",
        }
    },
    computed: {
        getUrl() {
            if (this.$route.query.page_ref) {
                return `/?page_ref=${this.$route.query.page_ref}`
            } else {
                return "/"
            }
        }
    },
    created() {
        // Redirect logged-in users away from login page
        if (this.$store.getters.isAuthenticated) {
            const pageRef = this.$route.query.page_ref
                ? this.extractFinalDestination(this.$route.query.page_ref)
                : '/home';
            this.$router.replace(pageRef);
        }

        // Prefill email: URL query param takes priority, then fall back to store
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const urlEmail = this.$route.query.email;
        if (urlEmail && emailRegex.test(urlEmail)) {
            this.email = urlEmail;
        } else {
            const user = this.$store.getters.user;
            if (user && user.email && emailRegex.test(user.email)) {
                this.email = user.email;
            }
        }
    },
    methods: {
        extractFinalDestination(url) {
            // Recursively decode and extract the final non-login destination
            let decoded = url;
            let prev = '';

            // Keep decoding until no more changes
            while (decoded !== prev) {
                prev = decoded;
                try {
                    decoded = decodeURIComponent(decoded);
                } catch (e) {
                    break;
                }
            }

            // Check if it contains a page_ref parameter, extract the deepest destination
            const pageRefMatch = decoded.match(/page_ref=(.+)/);
            if (pageRefMatch) {
                return this.extractFinalDestination(pageRefMatch[1]);
            }

            // Remove any query string from the final path and check if it's a login page or root
            const pathOnly = decoded.split('?')[0];
            if (pathOnly === '/login' || pathOnly === 'login' || pathOnly === '/') {
                return '/home';
            }

            return pathOnly || '/home';
        },
        onSubmit() {
            this.submitted = true;
            this.err = false;
            this.$axios.post(`${this.baseUrl}/api/login`, {
                password: this.password,
                email: this.email.toLowerCase(),
            }).then(response => {
                if (response.data.status == 'success') {
                    this.$store.dispatch("doLogin", response.data);
                    let pageRef = this.$route.query.page_ref
                        ? this.extractFinalDestination(this.$route.query.page_ref)
                        : '/home';
                    if (pageRef === '/' || !pageRef) {
                        pageRef = '/home';
                    }
                    this.$router.push(pageRef);
                } else {
                    this.submitted = false;
                    this.err = true;
                    this.errmsg = response.data.message;
                }
            }).catch(error => {
                console.log(error.message)
                this.submitted = false;
                this.err = true;
                this.errmsg = 'Email or password entered is incorrect. Please try again or <router-link to="/forgot-password">reset your password.</router-link>'
            });

        },
    }
}
</script>
<style scoped>
.login_section .w-layout-blockcontainer.container-12.w-container {
    max-width: 540px;
    padding: 0;
}
@media (max-width: 768px) {
    .logContain {
        max-width: 95%;
    }
}
</style>